import React, { Component } from "react";
import * as PropTypes from "prop-types";
import { Col, Form, Modal, Row, Tabs } from "antd";

import moment from "moment";

import { functionsService } from "./../../redux/services";

import {
	UIDrawerForm,
	UIFormSection,
} from "./../../components";

import Employees from "./../Companies/Employees";
import { FunctionsInfoBanner } from "./create";

class Show extends Component {
	static propTypes = {
		visible: PropTypes.bool.isRequired,
		onClose: PropTypes.func.isRequired,
		external: PropTypes.bool,
	};

	constructor(props) {
		super(props);

		this.state = {
			isLoading: true,
			item: {},
			general_key: null
		};
	}

	onOpen = (uuid, key) => {
		this.setState({
			isLoading: true,
			item: {},
			general_key: key,
		});

		functionsService.show({ uuid })
			.then((response) => {
				const item = response.data.data;

				this.setState({
					isLoading: false,
					item: item,
				}, () => {
					this.tabEmployees && this.tabEmployees.init(item);
				});
			})
			.catch((data) => {
				Modal.error({
					title: "Ocorreu um erro!",
					content: String(data),
					onOk: () => {
						// Force close
						return this.onClose();
					}
				});
			});
	};

	onClose = () => {
		this.setState({
			item: {},
		});

		// Callback
		this.props.onClose();
	};

	render() {
		const { visible } = this.props;
		const { isLoading, item, general_key } = this.state;

		return (
			<UIDrawerForm
				visible={visible}
				width={1000}
				onClose={this.onClose}
				isLoading={isLoading}
				showBtnSave={false}
				icon={<i className="fal fa-user-tie" />}
				title="Visualizar função"
				subtitle="Consulte as informações e os funcionários da função.">
				<Form layout="vertical">
					<Tabs defaultActiveKey={general_key ?? "general"}>
						<Tabs.TabPane
							forceRender
							tab={<span className="tab-icon-label"><i className="fal fa-clipboard-list" /> Informações gerais</span>}
							key="general">
							<UIFormSection
								icon={<i className="fal fa-clipboard-list" />}
								title="Informações gerais"
								description="Dados de identificação da função.">
								<Row gutter={16}>
									<Col xs={24} md={16}>
										<Form.Item label="Nome da função">
											{item.nome ?? "-"}
										</Form.Item>
									</Col>
									<Col xs={24} md={8}>
										<Form.Item label="Status">
											<span className={`status-tag ${item.ativo == 1 ? "status-tag-success" : "status-tag-error"}`}>
												<i className="status-tag-dot" />
												{item.ativo == 1 ? "Ativo" : "Inativo"}
											</span>
										</Form.Item>
									</Col>
								</Row>
								<Row gutter={16}>
									<Col xs={24} md={8}>
										<Form.Item label="Criação">
											{item.created_at ? moment(item.created_at).calendar() : "-"}
										</Form.Item>
									</Col>
									<Col xs={24} md={8}>
										<Form.Item label="Última atualização">
											{item.updated_at ? moment(item.updated_at).calendar() : "-"}
										</Form.Item>
									</Col>
								</Row>
							</UIFormSection>
							<FunctionsInfoBanner />
						</Tabs.TabPane>
						<Tabs.TabPane
							forceRender
							tab={<span className="tab-icon-label"><i className="fal fa-users" /> Funcionários vinculados</span>}
							key="employees">
							<UIFormSection
								icon={<i className="fal fa-users" />}
								title="Funcionários vinculados a esta função"
								description="Lista de funcionários que possuem esta função atribuída.">
								<Employees
									filterBy="funcao"
									ref={el => this.tabEmployees = el}
								/>
							</UIFormSection>
						</Tabs.TabPane>
					</Tabs>
				</Form>
			</UIDrawerForm>
		)
	}
}

export default Show;
